export default {
  en: {
    opensettings: 'Settings',
  },
};
